import { PoolResponse } from "models/staking-liquidity/PoolResponse"
import { StakingInfoResponse } from "models/staking-liquidity/StakingInfoResponse"
import { useEffect, useState } from "react"
import { LIQUIDITY_STAKING_ADDRESS } from "utils/Constants"
import { copy, fromDenom } from "utils/Helpers"
import { querySmartContract } from "utils/RpcHelpers"

type Props = {
    onStakingInfoLoaded: (stakingInfo: StakingInfoResponse) => void,
    poolInfo?: PoolResponse
}

export function ValidatorInfoCard({ onStakingInfoLoaded, poolInfo }: Props) {
    const [stakingInfo, setStakingInfo] = useState<StakingInfoResponse>();
    const [dummyApr, setDummyApr] = useState<number>(0);

    const loadStakingInfo = async () => {
        const stakingInfo = await querySmartContract(LIQUIDITY_STAKING_ADDRESS, { staking_info: {} })
        setStakingInfo(stakingInfo)
        onStakingInfoLoaded(stakingInfo)
    }

    const loadDummyApr = async () => {
        const config = await querySmartContract(LIQUIDITY_STAKING_ADDRESS, { dummy_apr: {} })
        setDummyApr(Number(config.dummy_apr))
    }

    useEffect(() => {
        loadStakingInfo()
        loadDummyApr()
    }, [])

    return <div className="card">
        <div className="card h-100">
            <div className="card-header d-flex align-items-center justify-content-between pb-0">
                <div className="card-title mb-0">
                    <h5 className="">Staking Detail</h5>
                </div>
            </div>
            <div className="card-body">
                <div className="mb-3">
                    <label htmlFor="token-address" className="form-label">Token Address</label>
                    <div className="input-group">
                        <input
                            value={stakingInfo?.config.token_contract}
                            readOnly
                            id="token-address"
                            type="text"
                            className="form-control"
                        />
                        <button onClick={() => copy(stakingInfo?.config.token_contract ?? "")} className="btn btn-outline-primary" type="button">Copy</button>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-7 col-md-8">
                        <label htmlFor="token-name" className="form-label">Token Name</label>
                        <div className="input-group">
                            <input
                                value={stakingInfo?.token_info.name}
                                readOnly
                                id="token-name"
                                type="text"
                                className="form-control"
                            />
                        </div>
                    </div>
                    <div className="col-5 col-md-4">
                        <label htmlFor="token-symbol" className="form-label">Token Symbol</label>
                        <div className="input-group">
                            <input
                                value={stakingInfo?.token_info.symbol}
                                readOnly
                                id="token-symbol"
                                type="text"
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
                <div className="mb-3">
                    <label htmlFor="validator-address" className="form-label">Validator</label>
                    <div className="input-group">
                        <input
                            value={stakingInfo?.config.validator_address}
                            readOnly
                            id="validator-address"
                            type="text"
                            className="form-control"
                        />
                        <button onClick={() => copy(stakingInfo?.config.validator_address ?? "")} className="btn btn-outline-primary" type="button">Copy</button>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-8 col-md-9">
                        <label htmlFor="owner" className="form-label">Owner</label>
                        <div className="input-group">
                            <input
                                value={stakingInfo?.config.owner}
                                readOnly
                                id="owner"
                                type="text"
                                className="form-control"
                            />
                        </div>
                    </div>
                    <div className="col-4 col-md-3">
                        <label htmlFor="staking-apr" className="form-label">APR</label>
                        <div className="input-group">
                            <input
                                value={dummyApr * 100}
                                type="number"
                                min={0}
                                max={100}
                                className="form-control"
                                id="staking-apr"
                            />
                            <span className="input-group-text">%</span>
                        </div>
                    </div>
                </div>
                <div className="mb-3">
                    <label htmlFor="total-pool" className="form-label">Total Pool</label>
                    <div className="input-group">
                        <input
                            value={fromDenom(Number(poolInfo?.pool.total_pool ?? "0"), stakingInfo?.token_info.decimals ?? 6)}
                            readOnly
                            id="total-pool"
                            type="text"
                            className="form-control"
                        />
                        <span className="input-group-text">{stakingInfo?.token_info.symbol}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
}   